import React, { FC } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';

import { formatInputDuration } from 'src/shared/utils';
import { getDurationFormat } from 'src/store/user/user.selectors';

interface Props {
  duration: number;
}

export const TimesheetTotalDurationCell: FC<Props> = ({ duration }) => {
  const durationFormat = useSelector(getDurationFormat);

  return (
    <Stack width="100%" height="100%" justifyContent="center" alignItems="center">
      <Typography fontSize="0.875rem" fontWeight={500}>
        {formatInputDuration(duration, durationFormat, 'seconds', false)}
      </Typography>
    </Stack>
  );
};
